import * as React from 'react';
import { connect } from 'react-redux';

import './ClipsPage.css';

import { IClip } from '../api';
import {
    listClips,
    playClip,
} from '../thunks';
import { RootState } from '../types';

import Timestamp from '../components/Timestamp';

interface IProps {
    clips: IClip[],
    currentRecordingID: string | null,
    onPlay: (clip: IClip) => void,
    fetchClips: () => any,
}

export class ClipsPage extends React.Component<IProps> {

    public componentWillMount() {
        this.props.fetchClips();
    }

    public render() {
        const {clips} = this.props;
        return (<div className="clips-section container">
            <table className="clips-table">
                <tbody>{ clips.map(this.renderRow) }</tbody>
            </table>
        </div>)
    }

    private renderRow = (clip: IClip, idx: number) => {
        const {currentRecordingID} = this.props;
        return (<tr
            onClick={this.onPlay}
            data-idx={idx}
            className={
                "clip-row"
                + (currentRecordingID === clip.recording_id ? ' playing' : '')
            }
            key={clip.id}>
            <td className="timestamp">{
                clip.start
                ? <Timestamp currentTime={clip.start} />
                : '--'
            }</td>
            <td>{clip.text}</td>
        </tr>);
    }

    private onPlay = (e: React.MouseEvent<HTMLTableRowElement>) => {
        const {clips} = this.props;

        const {idx} = e.currentTarget.dataset;
        if (!idx) {
            return;
        }
        const clip = clips[idx];

        this.props.onPlay(clip);
    }

}

export const ClipsPageContainer = connect(
    ({clips, player}: RootState) => ({
        clips: Object.keys(clips.data).map(id => clips.data[id]),
        currentRecordingID: player.recordingId,
    }),
    dispatch => ({
        fetchClips: () => dispatch<any>(listClips()),
        onPlay: (clip: IClip) => { dispatch<any>(playClip(clip)) },
    }),
)(ClipsPage);

export default ClipsPageContainer;



// WEBPACK FOOTER //
// ./src/pages/ClipsPage.tsx